import React from 'react'

export default function SelectB_Item(props) {
  let contxt = null

  if (props.render) {
    contxt = props.render(props.item)
  } else if (props.tag) {
    contxt = props.tag
  } else {
    contxt = props.children
  }

  return (<div className={`options_Item ${props.isActive ? 'active' : ''}`} onClick={(e) => {
    props.change && props.change(props.item.id, props.item)
    e.stopPropagation()
  }}>
    {contxt}
  </div>)
}
console.log(React)
